import { render } from "./AuditTemplateContent.vue?vue&type=template&id=bed31cee&scoped=true"
import script from "./AuditTemplateContent.vue?vue&type=script&lang=js"
export * from "./AuditTemplateContent.vue?vue&type=script&lang=js"

import "./AuditTemplateContent.vue?vue&type=style&index=0&id=bed31cee&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed31cee"]])

export default __exports__